/** Slugs for `/casino-hub/:slug` dedicated game listing pages. */
export type CasinoHubSlug =
  | 'lightning'
  | 'marble-run'
  | 'aviator'
  | 'mines'
  | 'bikini-games'
  | 'chicken-color'

export type CasinoFirstStripKey =
  | 'ezugi'
  | 'lightning'
  | 'marblerun'
  | 'sexy'
  | 'aviator'
  | 'mines'
  | 'bikinigames'
  | 'chickencolor'

export const CASINO_HUB_META: Record<
  CasinoHubSlug,
  { title: string; subtitle: string }
> = {
  lightning: {
    title: 'Lightning',
    subtitle: 'Lightning Roulette, Baccarat, Blackjack and more',
  },
  'marble-run': {
    title: 'Marble Run',
    subtitle: 'Ball racing and marble-style instant games',
  },
  aviator: {
    title: 'Aviator',
    subtitle: 'Crash and aviator-style games',
  },
  mines: {
    title: 'Mines',
    subtitle: 'Mines and mine-field instant games',
  },
  'bikini-games': {
    title: 'Bikini Games',
    subtitle: 'Bikini-themed slot and arcade games',
  },
  'chicken-color': {
    title: 'Chicken Road & Color Prediction',
    subtitle: 'Chicken Road and Color Prediction games',
  },
}

/** Deep links for dashboard casino-first-strip tiles. */
export const CASINO_FIRST_STRIP_LINKS: Record<CasinoFirstStripKey, string> = {
  ezugi: '/casino-int/slots?category=Ezugi',
  lightning: '/casino-hub/lightning',
  marblerun: '/casino-hub/marble-run',
  sexy: '/casino-int/slots?category=EazyGaming',
  aviator: '/casino-hub/aviator',
  mines: '/casino-hub/mines',
  bikinigames: '/casino-hub/bikini-games',
  chickencolor: '/casino-hub/chicken-color',
}
